export default {"src":"/canvas/_next/static/media/icon-google-t5.2139970b.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};